/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { ILayout } from "@/interfaces/layout/ILayout";

export const ui = {
    state: {
        layout: "main-layout",
        drawer: false,
        cardMode: true,
        lessonActive: 'TODAS'
    },
    mutations: {
        SET_LAYOUT(state: IState, newLayout: any) {
            state.layout = newLayout;
        },
        UPDATE_DRAWER(state: IState, payload) {
            state.drawer = payload;
        },
        TOGGLE_LIST_MODE(state: IState) {
            state.cardMode = !state.cardMode;
        },
        SET_LESSON_ACTIVE(state: any, payload: any) {
            state.lessonActive = payload;
        }
    },
    actions: {
        setLayout(context: any, payload: ILayout) {
            context.commit("SET_LAYOUT", payload);
        },
        toggleDrawer(context: any, payload) {
            context.commit("UPDATE_DRAWER", payload);
        },
        toggleListMode(context: any) {
            context.commit("TOGGLE_LIST_MODE");
        },
        changeLessonActive(context: any, payload: any) {
            context.commit("SET_LESSON_ACTIVE", payload);
        }
    },
    getters: {
        getLayout(state: IState) {
            return state.layout;
        },
        getDrawer(state: IState) {
            return state.drawer;
        },
        getCardMode(state: IState) {
            return state.cardMode;
        },
        getLessonActive(state: any) {
            return state.lessonActive;
        }
    }
};
